module.exports = {
    ADMIN_SERVICE: '/permission/',
    USDT_SERVICE: '/permission/proxy/',
    REPORT_SERVICE: '/permission/proxy-report/',
    TWO_FACTORY_VALIDATE: true,
    ENV: 'prod',
}
